module.exports = __webpack_public_path__ + "img/joodskindermonument_wolkachterin_600x600px.9e420385.png";